import { ManagementPage } from '@apps-common/apps/portal/pages/management/Index'

export const Management = () => <ManagementPage />
